var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStats = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3 15.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-5ZM7 10.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-10ZM11 12.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-8ZM15 9.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-11ZM19 3.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v17a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-17Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.621 5.937a1.001 1.001 0 0 1 1.034-.083L11.97 7.51l3.491-3.926.072-.074a1 1 0 0 1 1.422 1.402l-4 4.5a1 1 0 0 1-1.039.293l-.155-.063-3.355-1.678-3.49 3.49-.076.07A1 1 0 0 1 3.5 10.04l4-4 .121-.104Z"
})));
SvgStats.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgStats);
export default ForwardRef;